export const globalNationalitiesDropList = [
  { "name": "Select Nationality", "value": "" },
  { "name": "British", "value": "british" },
  { "name": "Afghan", "value": "afghan" },
  { "name": "Albanian", "value": "albanian" },
  { "name": "Algerian", "value": "algerian" },
  { "name": "American", "value": "american" },
  { "name": "Andorran", "value": "andorran" },
  { "name": "Angolan", "value": "angolan" },
  { "name": "Anguillan", "value": "anguillan" },
  { "name": "Citizen of Antigua and Barbuda", "value": "citizen_of_antigua_and_barbuda" },
  { "name": "Argentine", "value": "argentine" },
  { "name": "Armenian", "value": "armenian" },
  { "name": "Australian", "value": "australian" },
  { "name": "Austrian", "value": "austrian" },
  { "name": "Azerbaijani", "value": "azerbaijani" },

  { "name": "Bahamian", "value": "bahamian" },
  { "name": "Bahraini", "value": "bahraini" },
  { "name": "Bangladeshi", "value": "bangladeshi" },
  { "name": "Barbadian", "value": "barbadian" },
  { "name": "Belarusian", "value": "belarusian" },
  { "name": "Belgian", "value": "belgian" },
  { "name": "Belizean", "value": "belizean" },
  { "name": "Beninese", "value": "beninese" },
  { "name": "Bermudian", "value": "bermudian" },
  { "name": "Bhutanese", "value": "bhutanese" },
  { "name": "Bolivian", "value": "bolivian" },
  { "name": "Citizen of Bosnia and Herzegovina", "value": "citizen_of_bosnia_and_herzegovina" },
  { "name": "Botswanan", "value": "botswanan" },
  { "name": "Brazilian", "value": "brazilian" },
  { "name": "British Virgin Islander", "value": "british_virgin_islander" },
  { "name": "Bruneian", "value": "bruneian" },
  { "name": "Bulgarian", "value": "bulgarian" },
  { "name": "Burkinan", "value": "burkinan" },
  { "name": "Burmese", "value": "burmese" },
  { "name": "Burundian", "value": "burundian" },

  { "name": "Cambodian", "value": "cambodian" },
  { "name": "Cameroonian", "value": "cameroonian" },
  { "name": "Canadian", "value": "canadian" },
  { "name": "Cape Verdean", "value": "cape_verdean" },
  { "name": "Cayman Islander", "value": "cayman_islander" },
  { "name": "Central African", "value": "central_african" },
  { "name": "Chadian", "value": "chadian" },
  { "name": "Chilean", "value": "chilean" },
  { "name": "Chinese", "value": "chinese" },
  { "name": "Colombian", "value": "colombian" },
  { "name": "Comoran", "value": "comoran" },
  { "name": "Congolese (Congo)", "value": "congolese_congo" },
  { "name": "Congolese (DRC)", "value": "congolese_drc" },
  { "name": "Cook Islander", "value": "cook_islander" },
  { "name": "Costa Rican", "value": "costa_rican" },
  { "name": "Croatian", "value": "croatian" },
  { "name": "Cuban", "value": "cuban" },
  { "name": "Cymraes", "value": "cymraes" },
  { "name": "Cymro", "value": "cymro" },
  { "name": "Cypriot", "value": "cypriot" },
  { "name": "Czech", "value": "czech" },

  { "name": "Danish", "value": "danish" },
  { "name": "Djiboutian", "value": "djiboutian" },
  { "name": "Dominican", "value": "dominican" },
  { "name": "Citizen of the Dominican Republic", "value": "citizen_of_the_dominican_republic" },
  { "name": "Dutch", "value": "dutch" },

  { "name": "East Timorese", "value": "east_timorese" },
  { "name": "Ecuadorean", "value": "ecuadorean" },
  { "name": "Egyptian", "value": "egyptian" },
  { "name": "Emirati", "value": "emirati" },
  { "name": "English", "value": "english" },
  { "name": "Equatorial Guinean", "value": "equatorial_guinean" },
  { "name": "Eritrean", "value": "eritrean" },
  { "name": "Estonian", "value": "estonian" },
  { "name": "Ethiopian", "value": "ethiopian" },

  { "name": "Faroese", "value": "faroese" },
  { "name": "Fijian", "value": "fijian" },
  { "name": "Filipino", "value": "filipino" },
  { "name": "Finnish", "value": "finnish" },
  { "name": "French", "value": "french" },

  { "name": "Gabonese", "value": "gabonese" },
  { "name": "Gambian", "value": "gambian" },
  { "name": "Georgian", "value": "georgian" },
  { "name": "German", "value": "german" },
  { "name": "Ghanaian", "value": "ghanaian" },
  { "name": "Gibraltarian", "value": "gibraltarian" },
  { "name": "Greek", "value": "greek" },
  { "name": "Greenlandic", "value": "greenlandic" },
  { "name": "Grenadian", "value": "grenadian" },
  { "name": "Guamanian", "value": "guamanian" },
  { "name": "Guatemalan", "value": "guatemalan" },
  { "name": "Citizen of Guinea-Bissau", "value": "citizen_of_guinea_bissau" },
  { "name": "Guinean", "value": "guinean" },
  { "name": "Guyanese", "value": "guyanese" },

  { "name": "Haitian", "value": "haitian" },
  { "name": "Honduran", "value": "honduran" },
  { "name": "Hong Konger", "value": "hong_konger" },
  { "name": "Hungarian", "value": "hungarian" },

  { "name": "Icelandic", "value": "icelandic" },
  { "name": "Indian", "value": "indian" },
  { "name": "Indonesian", "value": "indonesian" },
  { "name": "Iranian", "value": "iranian" },
  { "name": "Iraqi", "value": "iraqi" },
  { "name": "Irish", "value": "irish" },
  { "name": "Israeli", "value": "israeli" },
  { "name": "Italian", "value": "italian" },
  { "name": "Ivorian", "value": "ivorian" },

  { "name": "Jamaican", "value": "jamaican" },
  { "name": "Japanese", "value": "japanese" },
  { "name": "Jordanian", "value": "jordanian" },

  { "name": "Kazakh", "value": "kazakh" },
  { "name": "Kenyan", "value": "kenyan" },
  { "name": "Kittitian", "value": "kittitian" },
  { "name": "Citizen of Kiribati", "value": "citizen_of_kiribati" },
  { "name": "Kosovan", "value": "kosovan" },
  { "name": "Kuwaiti", "value": "kuwaiti" },
  { "name": "Kyrgyz", "value": "kyrgyz" },

  { "name": "Lao", "value": "lao" },
  { "name": "Latvian", "value": "latvian" },
  { "name": "Lebanese", "value": "lebanese" },
  { "name": "Liberian", "value": "liberian" },
  { "name": "Libyan", "value": "libyan" },
  { "name": "Liechtenstein citizen", "value": "liechtenstein_citizen" },
  { "name": "Lithuanian", "value": "lithuanian" },
  { "name": "Luxembourger", "value": "luxembourger" },

  { "name": "Macanese", "value": "macanese" },
  { "name": "Macedonian", "value": "macedonian" },
  { "name": "Malagasy", "value": "malagasy" },
  { "name": "Malawian", "value": "malawian" },
  { "name": "Malaysian", "value": "malaysian" },
  { "name": "Maldivian", "value": "maldivian" },
  { "name": "Malian", "value": "malian" },
  { "name": "Maltese", "value": "maltese" },
  { "name": "Marshallese", "value": "marshallese" },
  { "name": "Martiniquais", "value": "martiniquais" },
  { "name": "Mauritanian", "value": "mauritanian" },
  { "name": "Mauritian", "value": "mauritian" },
  { "name": "Mexican", "value": "mexican" },
  { "name": "Micronesian", "value": "micronesian" },
  { "name": "Moldovan", "value": "moldovan" },
  { "name": "Monegasque", "value": "monegasque" },
  { "name": "Mongolian", "value": "mongolian" },
  { "name": "Montenegrin", "value": "montenegrin" },
  { "name": "Montserratian", "value": "montserratian" },
  { "name": "Moroccan", "value": "moroccan" },
  { "name": "Mosotho", "value": "mosotho" },
  { "name": "Mozambican", "value": "mozambican" },

  { "name": "Namibian", "value": "namibian" },
  { "name": "Nauruan", "value": "nauruan" },
  { "name": "Nepalese", "value": "nepalese" },
  { "name": "New Zealander", "value": "new_zealander" },
  { "name": "Nicaraguan", "value": "nicaraguan" },
  { "name": "Nigerian", "value": "nigerian" },
  { "name": "Nigerien", "value": "nigerien" },
  { "name": "Niuean", "value": "niuean" },
  { "name": "North Korean", "value": "north_korean" },
  { "name": "Northern Irish", "value": "northern_irish" },
  { "name": "Norwegian", "value": "norwegian" },

  { "name": "Omani", "value": "omani" },

  { "name": "Pakistani", "value": "pakistani" },
  { "name": "Palauan", "value": "palauan" },
  { "name": "Palestinian", "value": "palestinian" },
  { "name": "Panamanian", "value": "panamanian" },
  { "name": "Papua New Guinean", "value": "papua_new_guinean" },
  { "name": "Paraguayan", "value": "paraguayan" },
  { "name": "Peruvian", "value": "peruvian" },
  { "name": "Pitcairn Islander", "value": "pitcairn_islander" },
  { "name": "Polish", "value": "polish" },
  { "name": "Portuguese", "value": "portuguese" },
  { "name": "Prydeinig", "value": "prydeinig" },
  { "name": "Puerto Rican", "value": "puerto_rican" },

  { "name": "Qatari", "value": "qatari" },

  { "name": "Romanian", "value": "romanian" },
  { "name": "Russian", "value": "russian" },
  { "name": "Rwandan", "value": "rwandan" },

  { "name": "Salvadorean", "value": "salvadorean" },
  { "name": "Sammarinese", "value": "sammarinese" },
  { "name": "Samoan", "value": "samoan" },
  { "name": "Sao Tomean", "value": "sao_tomean" },
  { "name": "Saudi Arabian", "value": "saudi_arabian" },
  { "name": "Scottish", "value": "scottish" },
  { "name": "Senegalese", "value": "senegalese" },
  { "name": "Serbian", "value": "serbian" },
  { "name": "Citizen of Seychelles", "value": "citizen_of_seychelles" },
  { "name": "Sierra Leonean", "value": "sierra_leonean" },
  { "name": "Singaporean", "value": "singaporean" },
  { "name": "Slovak", "value": "slovak" },
  { "name": "Slovenian", "value": "slovenian" },
  { "name": "Solomon Islander", "value": "solomon_islander" },
  { "name": "Somali", "value": "somali" },
  { "name": "South African", "value": "south_african" },
  { "name": "South Korean", "value": "south_korean" },
  { "name": "South Sudanese", "value": "south_sudanese" },
  { "name": "Spanish", "value": "spanish" },
  { "name": "Sri Lankan", "value": "sri_lankan" },
  { "name": "St Helenian", "value": "st_helenian" },
  { "name": "St Lucian", "value": "st_lucian" },
  { "name": "Stateless", "value": "stateless" },
  { "name": "Sudanese", "value": "sudanese" },
  { "name": "Surinamese", "value": "surinamese" },
  { "name": "Swazi", "value": "swazi" },
  { "name": "Swedish", "value": "swedish" },
  { "name": "Swiss", "value": "swiss" },
  { "name": "Syrian", "value": "syrian" },

  { "name": "Taiwanese", "value": "taiwanese" },
  { "name": "Tajik", "value": "tajik" },
  { "name": "Tanzanian", "value": "tanzanian" },
  { "name": "Thai", "value": "thai" },
  { "name": "Togolese", "value": "togolese" },
  { "name": "Tongan", "value": "tongan" },
  { "name": "Trinidadian", "value": "trinidadian" },
  { "name": "Tristanian", "value": "tristanian" },
  { "name": "Tunisian", "value": "tunisian" },
  { "name": "Turkish", "value": "turkish" },
  { "name": "Turkmen", "value": "turkmen" },
  { "name": "Turks and Caicos Islander", "value": "turks_and_caicos_islander" },
  { "name": "Tuvaluan", "value": "tuvaluan" },

  { "name": "Ugandan", "value": "ugandan" },
  { "name": "Ukrainian", "value": "ukrainian" },
  { "name": "Uruguayan", "value": "uruguayan" },
  { "name": "Uzbek", "value": "uzbek" },

  { "name": "Vatican citizen", "value": "vatican_citizen" },
  { "name": "Citizen of Vanuatu", "value": "citizen_of_vanuatu" },
  { "name": "Venezuelan", "value": "venezuelan" },
  { "name": "Vietnamese", "value": "vietnamese" },
  { "name": "Vincentian", "value": "vincentian" },

  { "name": "Wallisian", "value": "wallisian" },
  { "name": "Welsh", "value": "welsh" },

  { "name": "Yemeni", "value": "yemeni" },

  { "name": "Zambian", "value": "zambian" },
  { "name": "Zimbabwean", "value": "zimbabwean" }
];